import {lowerFirst, upperFirst} from "@pg-mono/nodash";

import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {getOfferTypeNamePlural} from "../../../offer/helpers/OfferType";
import {OfferType} from "../../../offer/types/OfferType";
import {InvestmentOfferTypeSlug} from "../../constants/investment_offer_constants";
import {IParsedInvestmentOfferCategories} from "../actions/parse_investment_offer_url";

export const getInvestmentOffersHeader = (
    categories: IParsedInvestmentOfferCategories,
    pageTitle: string,
    offerType?: number
): {prefix: string; text: string} => {
    if (categories.category === InvestmentOfferTypeSlug.ABROAD && categories.subcategory) {
        if (offerType) {
            const type = getOfferTypeNamePlural(offerType == 1 ? OfferType.FLAT : offerType == 2 ? OfferType.HOUSE : OfferType.COMMERCIAL);
            return {
                prefix: "",
                text: `Nieruchomości ${upperFirst(categories.subcategory)} - ${type} na sprzedaż`
            };
        }
        return {
            prefix: "",
            text: `Nieruchomości ${upperFirst(categories.subcategory)} - apartamenty i domy na sprzedaż`
        };
    }
    if (categories.category === InvestmentOfferTypeSlug.ABROAD) {
        return {
            prefix: "Szukasz",
            text: `nieruchomości ${categories.subcategory ? upperFirst(categories.subcategory) : "za granicą"} - inwestuj i zarabiaj`
        };
    }

    return {
        prefix: "Szukasz",
        text: lowerFirst(pageTitle.replace(concatWithBrandName(" -"), ""))
    };
};
import {lowerFirst, upperFirst} from "@pg-mono/nodash";

import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {getOfferTypeNamePlural} from "../../../offer/helpers/OfferType";
import {OfferType} from "../../../offer/types/OfferType";
import {InvestmentOfferTypeSlug} from "../../constants/investment_offer_constants";
import {IParsedInvestmentOfferCategories} from "../actions/parse_investment_offer_url";

export const getInvestmentOffersHeader = (
    categories: IParsedInvestmentOfferCategories,
    pageTitle: string,
    offerType?: number
): {prefix: string; text: string} => {
    if (categories.category === InvestmentOfferTypeSlug.ABROAD && categories.subcategory) {
        if (offerType) {
            const type = getOfferTypeNamePlural(offerType == 1 ? OfferType.FLAT : offerType == 2 ? OfferType.HOUSE : OfferType.COMMERCIAL);
            return {
                prefix: "",
                text: `Nieruchomości ${upperFirst(categories.subcategory)} - ${type} na sprzedaż`
            };
        }
        return {
            prefix: "",
            text: `Nieruchomości ${upperFirst(categories.subcategory)} - apartamenty i domy na sprzedaż`
        };
    }
    if (categories.category === InvestmentOfferTypeSlug.ABROAD) {
        return {
            prefix: "Szukasz",
            text: `nieruchomości ${categories.subcategory ? upperFirst(categories.subcategory) : "za granicą"} - inwestuj i zarabiaj`
        };
    }

    return {
        prefix: "Szukasz",
        text: lowerFirst(pageTitle.replace(concatWithBrandName(" -"), ""))
    };
};
